import Charging from 'components/common/Charging';
import useAuth from 'hooks/useAuth';
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

const ChangeCompany = () => {
 const { validateLogin, isLoading } = useAuth('validate');

 useEffect(() => {
  validateLogin(true, 0, false);
 }, []);

 if (isLoading) return <Charging />;
 return <Navigate to="/app/calendar" replace />;
};

export default ChangeCompany;
